import _ from "lodash";
import { isValuePresent, parsedSpacingValue } from "../../utils/builderUtils";

// converts old database values to current values
const backport = (element) => {
  let options = { ...element.options };
  const levelsMap = {
    0: 0,
    1: 15,
    2: 25,
    3: 40,
    4: 70,
    5: 120,
  };

  ["top", "bottom", "left", "right"].forEach((side) => {
    // desktop
    const desktopKey = "padding-" + side;
    const desktopValue = options[desktopKey];

    if (
      desktopValue &&
      typeof desktopValue == "string" &&
      desktopValue.indexOf("_") > -1
    ) {
      let level = desktopValue.split("_").pop();
      options[desktopKey] = levelsMap[level];
    }

    // mobile
    const mobileKey = "padding-mobile-" + side;
    const mobileValue = options[mobileKey];

    if (
      mobileValue &&
      typeof mobileValue == "string" &&
      mobileValue.indexOf("_") > -1
    ) {
      let level = mobileValue.split("_").pop();
      options[mobileKey] = levelsMap[level];
    }
  });

  if (
    _.isNil(options["padding-top"]) &&
    _.isNil(options["padding-bottom"]) &&
    options["cf-vspace"]
  ) {
    if (options["cf-vspace"] == "cf-little-vspace") {
      options["padding-top"] = 8;
      options["padding-bottom"] = 8;
    }

    if (options["cf-vspace"] == "cf-regular-vspace") {
      options["padding-top"] = 21;
      options["padding-bottom"] = 21;
    }

    if (options["cf-vspace"] == "cf-more-vspace") {
      options["padding-top"] = 32;
      options["padding-bottom"] = 32;
    }
  }

  return options;
};

export const resolveElementClasses = (element, editing) => {
  let options = element.options;
  let classes = `cf-cta-item cf-element ${
    element.element_type !== "html" ? "fr-view" : ""
  }`;

  if (element.loaded == false) {
    classes += " opacity-50 pointer-events-none";
  }

  if (element.element_type !== "html") {
    if (options["cf-alignment"]) {
      classes += " " + options["cf-alignment"];
    }

    if (element.options["cf-alignment-mobile"]) {
      classes += " " + options["cf-alignment-mobile"];
    }
  }

  if (options["hide-desktop"] == "true") {
    classes += " cf-hide-desktop";
  }

  if (options["hide-mobile"] == "true") {
    classes += " cf-hide-mobile";
  }

  if (options["custom-class"]) {
    classes += " " + options["custom-class"];
  }

  if (editing == true) {
    classes += " editing";
  }

  return classes;
};

export const buildElementStylesheet = (builder, device, cta, element) => {
  let options = backport(element);

  let element_types_with_space_manually_set = ["list"];
  let not_conditions = element_types_with_space_manually_set
    .map((e) => `:not([data-type='${e}'])`)
    .join("");

  // prettier-ignore
  const desktopStyles =
`#cta_${cta.id} .cf-element[data-element-id='${element.id}']${not_conditions} {
  padding-left: ${isValuePresent(options['padding-left']) == true ? parsedSpacingValue(options['padding-left']) : '0px'} !important;
  padding-right: ${isValuePresent(options['padding-right']) == true ? parsedSpacingValue(options['padding-right']) : '0px'} !important;
  padding-top: ${isValuePresent(options['padding-top']) == true ? parsedSpacingValue(options['padding-top']) : '0px'} !important;
  padding-bottom: ${isValuePresent(options['padding-bottom']) == true ? parsedSpacingValue(options['padding-bottom']) : '0px'} !important;
  margin-left: ${isValuePresent(options['margin-left']) == true ? parsedSpacingValue(options['margin-left']) : '0px'} !important;
  margin-right: ${isValuePresent(options['margin-right']) == true ? parsedSpacingValue(options['margin-right']) : '0px'} !important;
  margin-top: ${isValuePresent(options['margin-top']) == true ? parsedSpacingValue(options['margin-top']) : '0px'} !important;
  margin-bottom: ${isValuePresent(options['margin-bottom']) == true ? parsedSpacingValue(options['margin-bottom']) : '0px'} !important;
}
`;

  // prettier-ignore
  const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"]${not_conditions} {
  ${isValuePresent(options['padding-mobile-left']) == true ? 'padding-left: ' + parsedSpacingValue(options['padding-mobile-left']) + '!important;' : ''}
  ${isValuePresent(options['padding-mobile-right']) == true ? 'padding-right: ' + parsedSpacingValue(options['padding-mobile-right']) + '!important;' : ''}
  ${isValuePresent(options['padding-mobile-top']) == true ? 'padding-top: ' + parsedSpacingValue(options['padding-mobile-top']) + '!important;' : ''}
  ${isValuePresent(options['padding-mobile-bottom']) == true ? 'padding-bottom: ' + parsedSpacingValue(options['padding-mobile-bottom']) + '!important;' : ''}
  ${isValuePresent(options['margin-mobile-left']) == true ? 'margin-left: ' + parsedSpacingValue(options['margin-mobile-left']) + '!important;' : ''}
  ${isValuePresent(options['margin-mobile-right']) == true ? 'margin-right: ' + parsedSpacingValue(options['margin-mobile-right']) + '!important;' : ''}
  ${isValuePresent(options['margin-mobile-top']) == true ? 'margin-top: ' + parsedSpacingValue(options['margin-mobile-top']) + '!important;' : ''}
  ${isValuePresent(options['margin-mobile-bottom']) == true ? 'margin-bottom: ' + parsedSpacingValue(options['margin-mobile-bottom']) + '!important;' : ''}
}`;

  if (builder !== true) {
    return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
  } else {
    if (device == "desktop") {
      return desktopStyles;
    } else {
      return desktopStyles + mobileStyles;
    }
  }
};
